<template>
    <!-- 用户层级 -->
    <div class="userLevel-container">
        <el-card shadow="always">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入代理账号"></el-input>
                </el-form-item>
				<el-form-item>
				    <el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理编号"></el-input>
				</el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card shadow="always" style="margin-top:10px">
            <el-button
                size="medium"
                icon="el-icon-folder"
                style="font-size: 12px;margin-bottom:20px"
                @click="handleClose()"
            >全部收起</el-button>
            <el-table
                v-if="refreshTable"
                ref="userLevel"
                :data="userList"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                lazy
                :load="load"
                size="small"
                :default-expand-all="expands"
                max-height="800px"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				:row-class-name="searchTab"
				:row-style="searchList"
            >
                <el-table-column
                    align="left"
                    header-align="center"
                    prop="name"
                    label="代理名称"
                    min-width="300"
                >
                    <template slot-scope="scope">
                        <img
                            :src="scope.row.avatar"
                            alt
                            class="user-img"
                            @click="viewImage(scope.row.avatar)"
                        />
                        <span style="margin-left:5px">{{scope.row.nickname}} {{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    prop="is_center_text"
                    label="是否运营中心"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    header-align="center"
                    prop="phone"
                    label="代理账号"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
              <el-table-column
                  align="center"
                  header-align="center"
                  prop="agent_no"
                  label="代理编号"
                  min-width="150"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.agent_no }}</p>
                </template>
              </el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                        <el-button v-if="scope.row.is_center==1"  @click="centerClick(2,scope.row)" type="text" size="small">标记运营中心</el-button>
                        <el-button style="color: red;" v-if="scope.row.is_center==2" @click="centerClick(1,scope.row)" type="text" size="small">取消运营中心</el-button>
                        <el-button v-if="scope.row.is_center==2"  @click="centerClick(3,scope.row)" type="text" size="small">查看标记结算价</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 加载时占位 -->
            <div v-if="!refreshTable" v-loading="loading" element-loading-text="嘿咻嘿咻拼命加载中！">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple-dark"></div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                </el-row>
                <el-row>
                    <div v-for="n in 10" :key="n">
                        <el-col :span="8">
                            <div class="grid-content bg-purple"></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-light"></div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple"></div>
                        </el-col>
                    </div>
                </el-row>
            </div>
            <preview-pic
                v-if="picInfo.isShow"
                :picInfo="picInfo"
                @handleCloseImgView="handleCloseImgView"
            ></preview-pic>
        </el-card>
        
        <el-dialog
          title="温馨提示"
          :visible.sync="cancelDiog"
          width="30%">
          <div>确定取消【{{mainItem.nickname}}】运营中心的权限？</div>
          <div>取消后代理商结算价恢复，是否取消？</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelDiog = false">取 消</el-button>
            <el-button type="primary" @click="cancelTrueClick">确 定</el-button>
          </span>
        </el-dialog>
        
        <el-dialog
          title="标记运营中心"
          :visible.sync="biaoDiog"
          width="60%">
          <el-form style = "width: 90%;" class="demo-form-inline" :model="form" label-width="100px"  ref="ruleForm">
          	<el-form-item label="选择政策:" prop="brand_id">
          		<el-select :disabled="is_center == 3"  multiple size clearable v-model="form.brand_id" placeholder="请选择政策"  style="width:90%;" @change="oneBrandChange">
          			<el-option :label="item.brand_name" :value="item.id" v-for="(item,index) in oneBrandList"></el-option>
          		</el-select>
          	</el-form-item>
            <el-form-item label="标记结算价:" prop="user_rate" style="margin-top: 10px;">
            	<el-select :disabled="is_center == 3"  size clearable v-model="form.user_rate" placeholder="请选择标记结算价"  style="width:90%;">
            		<el-option label="0.51" :value="0.51"></el-option>
            		<el-option label="0.515" :value="0.515"></el-option>
            		<el-option label="0.52" :value="0.52"></el-option>
            		<el-option label="0.525" :value="0.525"></el-option>
            		<el-option label="0.53" :value="0.53"></el-option>
            		<el-option label="0.535" :value="0.535"></el-option>
            		<el-option label="0.54" :value="0.54"></el-option>
            		<el-option label="0.545" :value="0.545"></el-option>
            		<el-option label="0.55" :value="0.55"></el-option>
            	</el-select>
                <span style="marginLeft:10px;">%</span>
            </el-form-item>
          </el-form>
          
          <el-form style = "width: 90%;margin-top: 30px;" class="demo-form-inline" :model="form2" label-width="100px"  ref="ruleForm">
          	<el-form-item label="选择政策:" prop="brand_id">
          		<el-select :disabled="is_center == 3"  multiple size clearable v-model="form2.brand_id" placeholder="请选择政策"  style="width:90%;" @change="twoBrandChange">
          			<el-option :label="item.brand_name" :value="item.id" v-for="(item,index) in twoBrandList"></el-option>
          		</el-select>
          	</el-form-item>
            <el-form-item label="标记结算价:" prop="user_rate" style="margin-top: 10px;">
            	<el-select :disabled="is_center == 3" size clearable v-model="form2.user_rate" placeholder="请选择标记结算价"  style="width:90%;">
            		<el-option label="0.51" :value="0.51"></el-option>
            		<el-option label="0.515" :value="0.515"></el-option>
            		<el-option label="0.52" :value="0.52"></el-option>
            		<el-option label="0.525" :value="0.525"></el-option>
            		<el-option label="0.53" :value="0.53"></el-option>
            		<el-option label="0.535" :value="0.535"></el-option>
            		<el-option label="0.54" :value="0.54"></el-option>
            		<el-option label="0.545" :value="0.545"></el-option>
            		<el-option label="0.55" :value="0.55"></el-option>
            	</el-select>
                <span style="marginLeft:10px;">%</span>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer" v-if="is_center == 2">
            <el-button @click="biaoDiog = false">取 消</el-button>
            <el-button type="primary" @click="biaoTrueClick">确 定</el-button>
          </span>
        </el-dialog>
        
    </div>
</template>

<script>
import previewPic from '../../components/previewPic'; //图片预览组件
export default {
    data() {
        return {
            refreshTable: false,
            expands: false, //是否自动展开
            picInfo: {
                isShow: false,
                imgUrl: ''
            },
            loading: false,
            searchForm: {
                phone: '',
                agent_no: '',
                is_center:''
            },
            downLoading: false, //导出loading
            userList: [],
            cancelDiog:false,
            biaoDiog:false,
            mainItem:{},
            form:{
                brand_id:[],
                user_rate:''
            },
            form2:{
                brand_id:[],
                user_rate:''
            },
            brandList:[],
            oneBrandList:[],
            twoBrandList:[],
            is_center:0
        }
    },
    mounted() {
        this.getUserList({});
        
    },
    components: {
        previewPic
    },
    methods: {
        oneBrandChange(e){
            let arr = JSON.parse(JSON.stringify(this.brandList))
            this.twoBrandList = arr
            for (let id of e) {
               this.twoBrandList = this.removeElement(this.twoBrandList,id) 
            }
            
        },
        removeElement(arr, id) {
          return arr.filter(function(value) {
            return value.id != id;
          });
        },

        twoBrandChange(e){
            let arr = JSON.parse(JSON.stringify(this.brandList))
            this.oneBrandList = arr
            for (let id of e) {
               this.oneBrandList = this.removeElement(this.oneBrandList,id) 
            }
        },
		searchTab({row,rowIndex}){
			row.index = rowIndex;
		},
		searchList({row,rowIndex}){
			if(row.is_search == 1){
				return{
					"background-color":"rgb(220,220,220)"
				}
			}
		},
        handleSearch(searchForm) { //搜索
            this.refreshTable = false;
            this.expands = /[\S]+/.test(searchForm.phone) ? true : false;
            this.getUserList(searchForm);
        },
        handleInfo(row) { //查看用户详情
            this.$router.push({ path: '/userInfo', query: { id: row.id } });
        },
        load(tree, treeNode, resolve) {//动态加载
            this.$api.post('user/underling', { pid: tree.id }, res => {
                resolve(res.data);
            })
        },
        centerClick(is_center,item){
            this.form = {
                brand_id:[],
                user_rate:''
            },
            this.form2 ={
                brand_id:[],
                user_rate:''
            }
            this.is_center = is_center
            this.$api.post('user_extend/getUserCenterInfo', {user_id:item.id}, res => { //获取管理奖规则
            	this.brandList = res.data.user_brand_list;
                this.oneBrandList = res.data.user_brand_list;
                this.twoBrandList = res.data.user_brand_list;
                let obj = res.data
                if (obj.is_center == 2 && obj.user_center_rate.length > 0) {
                    for (let item of obj.user_center_rate) {
                        item.brand_id = item.brand_id.split(',')
                        let arr = []
                        for (let num of item.brand_id) {
                            arr.push(parseInt(num)) 
                        }
                        item.brand_id = arr
                    }
                    this.form = obj.user_center_rate[0]
                    if (obj.user_center_rate.length == 2) {
                        this.form2 = obj.user_center_rate[1]
                    }
                    console.log(this.form);
                }
            });
            this.mainItem = item
            if (is_center == 1) {
                this.cancelDiog = true
            }else {
                this.biaoDiog = true
            }
        },
        cancelTrueClick(){
            
            this.$api.post('user_extend/saveUserCenter', {user_id:this.mainItem.id,is_center:1}, res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                    })
                    this.mainItem.is_center = 1
                    this.cancelDiog = false
                } else {
                    this.$message.error(res.msg);
                }
            })  
        },
        biaoTrueClick(){
            console.log(this.form);
             console.log(this.form2);
            
            let user_center_rate = []
            if (this.form.brand_id.length > 0 && this.form.user_rate > 0) {
                user_center_rate.push(JSON.parse(JSON.stringify(this.form)))
            }
            if (this.form2.brand_id.length > 0 && this.form2.user_rate > 0) {
                user_center_rate.push(JSON.parse(JSON.stringify(this.form2)))
            }
            if (user_center_rate.length == 0) {
                this.$message.error('请选择政策并选择对应结算价!');
                return
            }
            for (let item of user_center_rate) {
                console.log(item);
                item.brand_id = item.brand_id.join(',')
            }
            console.log(user_center_rate);
            this.$api.post('user_extend/saveUserCenter', {user_id:this.mainItem.id,is_center:2,user_center_rate:JSON.stringify(user_center_rate)}, res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                    })
                    this.form = {
                        brand_id:[],
                        user_rate:''
                    },
                    this.form2 ={
                        brand_id:[],
                        user_rate:''
                    }
                    this.mainItem.is_center = 2
                    this.biaoDiog = false
                } else {
                    this.$message.error(res.msg);
                }
            })  
            
        },
        handleClose() {//折叠
            this.refreshTable = false;
            this.expands = false;
            this.$nextTick(() => {
                this.refreshTable = true;
            });
        },
        getUserList(params) { //获取列表
            this.loading = true;
            this.$api.post('user/level', params, res => {
                if (res.code == 0) {
                    this.refreshTable = true;
                    this.userList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
                this.loading = false;
            })
        },
        viewImage(picUrl) { //预览图片
            if (picUrl != '') {
                this.picInfo.isShow = true;
                this.picInfo.imgUrl = picUrl;
            } else {
                this.$message.error('没有可以预览的图片哦！');
            }
        },
        handleCloseImgView() { //关闭图片预览
            this.picInfo.isShow = false;
            this.picInfo.imgUrl = '';
        },
    }
}

</script>

<style scoped lang="scss">
.userLevel-container {
    .user-img {
        width: 20px;
        height: 20px;
        vertical-align: text-bottom;
    }
    .el-row {
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        margin-bottom: 20px;
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
}
</style>